import { createLogger } from '@beef/metric';
import { debugLevel } from "./debug";
export var logger = createLogger('AutoMetric', debugLevel ? 'debug' : 'silent');
export { debugLevel } from "./debug";